import React, { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import './ContactForm.css';
import contactImage from './illustration.png';

const ContactForm = () => {
  const formRef = useRef();
  const [phone, setPhone] = useState('');

  const sendEmail = (e) => {
    e.preventDefault();

    const currentTime = new Date().toLocaleString();

    emailjs
      .send(
        "service_tmr9ga9",      // ✅ Service ID
        "template_wgwikln",     // ✅ Template ID
        {
          name: formRef.current.name.value,
          email: formRef.current.email.value,
          phone: phone,          // use state here
          message: formRef.current.message.value,
          time: currentTime,
        },
        "_B8HMTGOnNqAamxO0"     // ✅ Public Key
      )
      .then(
        () => {
          alert("Message sent successfully ✅");
          formRef.current.reset();
          setPhone('');
        },
        (error) => {
          console.error(error);
          alert("Failed to send message ❌");
        }
      );
  };

  return (
    <div className="contact-container">
      <div className="contact-image-section">
        <img
          src={contactImage}
          alt="3D character on a phone"
          className="contact-image"
        />
      </div>

      <div className="contact-form-section">
        <h2 className="contact-title">Contact us</h2>
        <p className="contact-subtitle">
          Fill out the form below and we'll get back to you soon!
        </p>

        <form ref={formRef} onSubmit={sendEmail}>
          <div className="form-group">
            <label>Name</label>
            <input type="text" name="name" required />
          </div>

          <div className="form-group">
            <label>E-mail address</label>
            <input type="email" name="email" required />
          </div>

          <div className="form-group">
            <label>Phone number</label>
            <PhoneInput
              country={'in'}        // default country, can be changed
              value={phone}
              onChange={setPhone}
              inputProps={{
                name: 'phone',
                required: true,
              }}
              enableSearch
            />
          </div>

          <div className="form-group">
            <label>Message</label>
            <textarea name="message" required></textarea>
          </div>

          <button type="submit" className="submit-button">
            Message
          </button>
        </form>
      </div>
    </div>
  );
};

export default ContactForm;
